module.exports = __webpack_public_path__ + "media/about-wave.55850161.webm";